<div>
  <h2>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_HEADER' | translate }}</h2>

  <form class="p-grid p-nogutter" [formGroup]="verificationFormGroup" (ngSubmit)="setPassword()">
    <div class="p-col-12">
      <aur-input #email [autofocus]="true" type="email" formControlName="email"
        [label]="'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate" [errorMessages]="{
        'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate,
        'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate
      }"></aur-input>
    </div>

    <div class="p-col-12">
      <aur-input formControlName="verificationCode"
        [label]="'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_LABEL' | translate"></aur-input>
    </div>
    <div class="p-col-12">
      <aur-notice class="email-sent-message" *ngIf="showMessage" severity="info">
        {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_EMAIL_SENT_MESSAGE_BODY' | translate}}
      </aur-notice>
    </div>
    <div class="p-col-12 submit-button-wrapper">
      <button type="submit" id="btnVerificationCode" class="set-password-button" aur-button>{{
        'ARC_SHARED_COMPONENTS_PRESENTATION_VERIFICATION_CODE_BUTTON' | translate }}</button>
    </div>

  </form>
  <div class="p-col-12 ui-md-12 back-button-wrapper">
    <button id="btnGoBack" (click)="goBack()" aur-button icon="arrow_back" importance="tertiary">
      {{ 'ARC_SHARED_COMPONENTS_BACK' | translate }}
    </button>

    <button (click)="resendCode($event)" aur-button importance="tertiary">{{
      'ARC_SHARED_COMPONENTS_FEATURE_CODEVERIFICATION_CODE_RESEND_BUTTON'
      | translate }}</button>
  </div>
</div>